export default __webpack_public_path__ + "static/media/mixer.880623e5.gif";